import { parseJsonSafe } from 'modules/reports/utils/parseJsonSafe';

import {
  ParsedDonorData,
  ParsedIneligibleReport,
  ParsedOwnerData,
} from '../types';

type RawIneligibleReport = {
  id: string;
  createdAt?: string | Date | null;
  ownerData: string;
  donorData: string;
  __typename?: string;
};

export const transformIneligibleData = (
  rawData: RawIneligibleReport[]
): ParsedIneligibleReport[] => {
  return rawData.map(({ __typename, ownerData, donorData, ...rest }) => ({
    ...rest,
    ownerData: parseJsonSafe<ParsedOwnerData>(ownerData, {}),
    donorData: parseJsonSafe<ParsedDonorData>(donorData, {}),
  }));
};
